import { createAsyncThunk } from "@reduxjs/toolkit";
import { 
  fetchProductDetail as fetchProductDetailService,
  fetchBottomGroupProducts as fetchBottomGroupProductsService,
  fetchModalContent as fetchModalContentService
} from "./productDetail.service";
import { ProductDetailResponse, BottomGroupProductsResponse, ModalContentResponse, ModalType } from "./productDetail.types";
import { handleApiError } from "@/app/utils/handleApiError";

export const getProductDetail = createAsyncThunk<
  ProductDetailResponse,
  { slug: string; variantId?: number; silent?: boolean },
  { rejectValue: string }
>("productDetail/getProductDetail", async ({ slug, variantId }, { rejectWithValue }) => {
  try {
    const response = await fetchProductDetailService(slug, variantId);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const getBottomGroupProducts = createAsyncThunk<
  BottomGroupProductsResponse,
  { productId: number; key: string },
  { rejectValue: string }
>("productDetail/getBottomGroupProducts", async ({ productId, key }, { rejectWithValue }) => {
  try {
    const response = await fetchBottomGroupProductsService(productId, key);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});

export const getModalContent = createAsyncThunk<
  ModalContentResponse,
  { productId: number; type: ModalType },
  { rejectValue: string }
>("productDetail/getModalContent", async ({ productId, type }, { rejectWithValue }) => {
  try {
    const response = await fetchModalContentService(productId, type);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});